import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Table, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Typeahead } from "react-bootstrap-typeahead";

import "react-datepicker/dist/react-datepicker.css";
import "../styles/VetTreatment.css";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";

export default function VetTreatment() {
  const [startDate, setStartDate] = useState(new Date());
  const [vet_visit, setVetVisit] = useState("No");
  const [vet_facility, setVetFacility] = useState("");
  const [reason, setReason] = useState("");
  const [medication, setMedication] = useState("No");
  const [medication_reason, setMedicationReason] = useState("");
  const [anaethesia, setAnaethesia] = useState("No");
  const [glucose_reading, setGlucoseReading] = useState("");
  const [body_temp, setBodyTemp] = useState("");
  const [drug_administered, setDrugAdministered] = useState("");
  const [volume, setVolume] = useState(0);
  const [method, setMethod] = useState("Subcut");
  const [comments, setComments] = useState("");
  const [reference_number, setReferenceNumber] = useState([]);
  const [body, setBody] = useState([]);
  const [options, setOptions] = useState([]);
  const [showSave, setShowSave] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  async function submit() {
    const ref = reference_number[0];
    const items = {
      date: startDate,
      reference_number: ref,
      vet_visit,
      vet_facility,
      reason,
      medication,
      medication_reason,
      anaethesia,
      glucose_reading,
      body_temp,
      drug_administered,
      volume,
      method,
      comments,
    };
    var result = await axiosInstance.post("/api/add-vet-treatment", items);
    if (result.data.code !== "ER_PARSE_ERROR") {
      toast.success(result.data, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
      setStartDate(new Date());
      setVetVisit("No");
      setVetFacility("");
      setReason("");
      setMedication("No");
      setMedicationReason("");
      setAnaethesia("No");
      setGlucoseReading("");
      setBodyTemp("");
      setDrugAdministered("");
      setVolume(0);
      setMethod("Subcut");
      setComments("");
      setReferenceNumber([]);
      setShowSuccess(true);
    } else {
      toast.error(result.data.sqlMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const handleCloseSave = () => setShowSave(false);
  const handleCloseSuccess = () => setShowSuccess(false);
  const handleSave = () => {
    submit();
    setShowSave(false);
  };
  function handleShowSave(e) {
    e.preventDefault();
    setShowSave(true);
  }

  async function getReferences() {
    const result = await axiosInstance.get("/api/all-reference-numbers");
    const numbers = result.data;
    const refs = [];
    numbers.forEach((element) => {
      refs.push(element.reference_number);
    });
    setOptions(refs);
  }

  useEffect(() => {
    getReferences();
  }, []);

  return (
    <div className="vet">
      <div className="formGroup">
        <h2 className="heading">Veterinary Treatment</h2>
        <Form.Group as={Col} controlId="formGroupDate">
          <DatePicker
            className="datepicker"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showTimeSelect
            timeIntervals={1}
            dateFormat="dd/MM/yyyy HH:mm"
          />
        </Form.Group>
        <Form>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupReference">
                <Form.Label>Reference Number</Form.Label>
                <Typeahead
                  id="reference-number"
                  labelKey="name"
                  onChange={setReferenceNumber}
                  options={options}
                  placeholder="Choose a reference number..."
                  selected={reference_number}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <Form.Group as={Col} controlId="formGroupVet">
                <Form.Label>Vet Visit</Form.Label>
                <Form.Check
                  type="radio"
                  id="vet-radio-yes"
                  label="Yes"
                  name="vetRadios"
                  value="Yes"
                  onChange={(e) => setVetVisit(e.target.value)}
                  checked={vet_visit === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="vet-radio-no"
                  label="No"
                  name="vetRadios"
                  value="No"
                  onChange={(e) => setVetVisit(e.target.value)}
                  checked={vet_visit === "No"}
                />
              </Form.Group>
            </Col>
            <Col xs={4}>
              <Form.Group as={Col} controlId="formGroupFacility">
                <Form.Label>Vet or Facility</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Vet or Facility"
                  value={vet_facility}
                  onChange={(e) => setVetFacility(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={8}>
              <Form.Group as={Col} controlId="formGroupDiagnosis">
                <Form.Label>
                  Reason for Vet Visit, Diagnosis and Treatment Plan
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Reason for Vet Visit, Diagnosis and Treatment Plan"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  disabled={vet_visit === "No"}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <Form.Group as={Col} controlId="formGroupMedication">
                <Form.Label>Medication</Form.Label>
                <Form.Check
                  type="radio"
                  id="vet-visit-radio-yes"
                  label="Yes"
                  name="medicationRadios"
                  value="Yes"
                  onChange={(e) => setMedication(e.target.value)}
                  checked={medication === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="vet-visit-radio-no"
                  label="No"
                  name="medicationRadios"
                  value="No"
                  onChange={(e) => setMedication(e.target.value)}
                  checked={medication === "No"}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupMedicationReason">
                <Form.Label>Reason for Medication and Time Frame</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Reason For Medication and Time Frame"
                  value={medication_reason}
                  onChange={(e) => setMedicationReason(e.target.value)}
                  disabled={medication === "No"}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupAnaesthesia">
                <Form.Label>Anaesthesia</Form.Label>
                <Form.Check
                  type="radio"
                  id="anaesthesia-radio-yes"
                  label="Yes"
                  name="anaesthesiaRadios"
                  value="Yes"
                  onChange={(e) => setAnaethesia(e.target.value)}
                  checked={anaethesia === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="anaesthesia-radio-no"
                  label="No"
                  name="anaesthesiaRadios"
                  value="No"
                  onChange={(e) => setAnaethesia(e.target.value)}
                  checked={anaethesia === "No"}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupGlucose">
                <Form.Label>Glucose Reading</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Glucose Reading"
                  value={glucose_reading}
                  onChange={(e) => setGlucoseReading(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupBodyTemp">
                <Form.Label>Body Temperature</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Body Temperature"
                  value={body_temp}
                  onChange={(e) => setBodyTemp(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDrug">
                <Form.Label>Drug Administered</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Drug Administered"
                  value={drug_administered}
                  onChange={(e) => setDrugAdministered(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupVolume">
                <Form.Label>Volume</Form.Label>
                <Row>
                  <Col xs={10}>
                    <Form.Control
                      type="text"
                      placeholder="Volume"
                      value={volume}
                      onChange={(e) => {
                        const regex = new RegExp(
                          "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                        );
                        if (regex.test(e.target.value)) {
                          const s = e.target.value.replace(
                            /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                            ""
                          );
                          setVolume(s);
                        } else if (e.target.value === "") {
                          setVolume(0);
                        }
                      }}
                    />
                  </Col>
                  <Col className="labelcol">
                    <Form.Label className="label">ml</Form.Label>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupHealth">
                <Form.Label>Method</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={method}
                  onChange={(e) => setMethod(e.target.value)}
                >
                  <option value="Subcut">Subcut</option>
                  <option value="I.M.">I.M.</option>
                  <option value="I.V.">I.V.</option>
                  <option value="Oral">Oral</option>
                </Form.Control>
                <br />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>
                  General Wound Treatment or Parasite Management
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="General Wound Treatment or Parasite Management"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          {/* <Table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Vet Name/Facility</th>
                <th>Reason for Vet Visit</th>
                <th>Anaethesia</th>
                <th>Glucose Reading</th>
                <th>Body Temperature</th>
                <th>Glucose Reading</th>
                <th>Reason for Medication</th>
                <th>Drug Administed</th>
                <th>Method</th>
                <th>Volume</th>
                <th>General Treatment</th>
              </tr>
            </thead>
            <tbody>{body}</tbody>
          </Table> */}

          <Row>
            <Col>
              <Button
                className="submit-button"
                type="submit"
                onClick={(e) => {
                  handleShowSave(e);
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>

      <div>
        <Modal show={showSave} onHide={handleCloseSave}>
          <Modal.Header closeButton>
            <Modal.Title>Save</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Are you sure you want to save this treatment.</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSave}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <Modal show={showSuccess} onHide={handleCloseSuccess}>
          <Modal.Header closeButton>
            <Modal.Title>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Successfuly Submited.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSuccess}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
